export const CONEXION_BASE = process.env.REACT_APP_CONEXION_BASE;
export const PORT = process.env.REACT_APP_PORT;
export const PORT_ANTERIOR = process.env.REACT_APP_PORT_ANTERIOR;
export const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME;
